<template>
<div class="SearchItem">
    <div class="item">
        <p class="name">{{name}}</p>
        <div class="msg">
            <span v-for="(item,index) in arrayList" :key="index" :class="{active: catecode == item.code}" @click="tabCatecode(item.code)">{{item.name}}</span>
        </div>
        <input type="text" :vaule="catecode" @input="tabCatecode">
        <!-- 用于数据双向绑定 -->
    </div>
</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'SearchItem',
  props: ['arrayList', 'name', 'active'], // 列表
  data () {
    return {
        catecode: this.active,    // 选中标签
        activeNum: 0   // 选中次数
    }
  },
  mounted () {
  },
  methods: {
    tabCatecode(code) {
        this.catecode = code
        this.$emit("input", code)
        this.$emit('searchclick', code)
    },
    ...mapActions([
        'setLoading'
    ])
  },
  filters: {},
  watch: {
      getarrayList() {
        if (this.activeNum > 0) {
          this.catecode = ''
        }
        this.activeNum ++
        // console.log('active', this.active)
        //   this.catecode = this.code
      }
  },
  computed: {
    getarrayList() {
        return this.arrayList
    },  
    ...mapGetters([
        'user'
    ])
  },
  components: {}
}
</script>
<style lang="scss" type="text/scss" >
.SearchItem {
    input {
        display: none;
    }
    .item {
        padding-top: 20px;
        overflow: hidden;
        border-top: solid 1px #eee;
    }
            .name {
                float: left;
                display: block;
                width: 83px;
            }    
            .msg {
                float: left;
                width: calc(100% - 83px);
            }

            span {
                float: left;
                display: inline-block;
                height: 20px;
                line-height: 20px;
                margin-bottom: 15px;
                font-size: 12px;
                margin-left: 30px;
                cursor: pointer;

                &.active {
                    font-size: 12px;
                    padding: 0 7px;
                    color: #fff;
                    background:#409EFF;
                    border-radius:10px;
                }
            }
}
</style>